import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AllocationDefinition } from '../domain/allocationdefinition';
import { AllocationDefinitionLine } from '../domain/allocationdefinitionline';
import { AllocationDefinitionService } from '../service/allocationdefinition.service';
import { Utils } from 'src/app/utilities/utils';
import { MessageService } from 'primeng/api';
import { ForeignKeyService, EditService, EditSettingsModel, ToolbarService, GridComponent, SaveEventArgs, SelectionSettingsModel, ToolbarItems, CellSelectEventArgs, ColumnModel, SortSettingsModel } from '@syncfusion/ej2-angular-grids';
import { LookupService } from '../service/lookup.service';
import { DropDownListModel, FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { EmitType } from '@syncfusion/ej2-base';
import { DataManager, Query, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ChangeDetectorRef } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';

@Component({
    templateUrl: './allocation-factors-edit.component.html'
})
export class AllocationFactorsEditComponent implements OnInit, AfterViewInit {
    //@ViewChild('GridAllocationFactors') gridAllFActors!: GridComponent;
    @ViewChild('GridAllocationFactors', { static: false }) gridAllFActors!: GridComponent;
    @ViewChild('allocationFactorsGridContainer', { static: false }) allocationFactorsGridContainer?: ElementRef<HTMLElement>;

    highlightedRecordId: number | null = null;
    pendingRestoreRecordId: number | null = null;
    pendingRestorePageNumber: number | null = null;
    counter: number;
    id: string;
    companyId: number;
    years: object[] = [];
    public dimensionValuesList?: any[] = [];


    object: AllocationDefinition;
    year: object;
    sourceDimension: string;
    sourceDimensionId: any;
    targetDimension: string;
    targetDimensionId: any;
    items?: any[] = [];
    totals: object = {
        m1: 0,
        m2: 0,
        m3: 0,
        m4: 0,
        m5: 0,
        m6: 0,
        m7: 0,
        m8: 0,
        m9: 0,
        m10: 0,
        m11: 0,
        m12: 0,
    };
    sumError: boolean = false;
    sourceDimensionValues: object[] = [];
    isDisabled: boolean = true;

    yesNoOptions = [
        { label: 'Yes', value: 'Y' },
        { label: 'No', value: 'N' }
    ];
    public toolbar?: ToolbarItems[];
    public editSettings?: EditSettingsModel;
    public checkMonthValueRule: object;
    public fields: Object = { text: "name", value: "id" };
    public sortOptions: SortSettingsModel = {
        columns: [{ field: 'ID', direction: 'Descending' }]
    };
    public filterOptions: Object = { type: 'Excel' };
    errorResp: any;


    columnSums: number[] = [];
    columnAggregates: { [key: string]: number } = {}; // To store aggregated values
    aggregatedSums: { [key: string]: number } = {};
    public editParams: Object;
    public editParams2: Object;
    public selectionOptions?: SelectionSettingsModel;
    public clipboardSettings?: any; // No need to import a model

    public dataManagerLines: DataManager | null = null;
    public dataManagerNew: DataManager;
    public gridHeight = 400;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private allocationDefinitionService: AllocationDefinitionService,
        private messageService: MessageService,
        private lookupService: LookupService,
        private cdRef: ChangeDetectorRef
    ) {

        this.checkMonthValueRule = {
            required: true,
            custom: [(args: { value: number }) => args.value <= 1, 'Value must be between 0 and 1']
        };


    }
    ngAfterViewInit(): void {
        setTimeout(() => this.updateGridHeight(), 0);
    }

    @HostListener('window:resize')
    onWindowResize(): void {
        this.updateGridHeight();
    }

    onCellSelected(args: CellSelectEventArgs): void {
        // Handle cell selection
        const cellValue = null;// args.cellElement.innerText;
        if (cellValue) {
            navigator.clipboard.writeText(cellValue).catch(err => {
                console.error('Failed to copy text:', err);
            });
        }
    }


    validationAgregates(): void {

        var a = document.getElementById('GridAllocationFactors');
        const grid = (a as any).ej2_instances[0];

        // const gridInstance = (document.getElementById('GridAllocationFactorsData') as any)?.ej2_instances?.[0];
        if (grid) {

            //grid.columns[1].dataSource = this.dimensionValuesList
            const dataSource = grid.dataSource as any[];
            if (!dataSource || dataSource.length === 0) {
                console.warn('Grid data source is empty');
                this.isDisabled = false;
                //return;
            }
            // Compute sums manually for the required fields
            const fields = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
            this.aggregatedSums = {}; // Reset aggregated sums

            fields.forEach((field) => {
                this.aggregatedSums[field] = dataSource.reduce((sum, item) => sum + (item[field] || 0), 0);
            });

        }

        this.validateAggregates();

    }

    onRowDataBound(args: any) {
        const rowElement = args.row as HTMLElement;

        if (rowElement) {
            rowElement.classList.toggle('restored-selected-row', args?.data?.ID === this.highlightedRecordId);
        }

        if (args.data && args.data.TargetDimensionValueID) {
            let targetID = args.data.TargetDimensionValueID;

            // Check if there are multiple rows with the same TargetDimensionValueID
            let duplicateRows = this.items.filter(item => item.TargetDimensionValueID === targetID);

            if (duplicateRows.length > 1) {
                args.row.style.backgroundColor = '#ffcccb'; // Light red for duplicate rows
            }
        }
    }

    onGridDataBound() {
        this.reselectLastRow();
        this.applyHighlightedRowState();
        this.updateGridHeight();
    }
    ngOnInit() {


        //this.columnSums



        // Update clipboard settings
        this.clipboardSettings = {
            allowCopy: true,
            allowPaste: true,
            columns: [
                // List all columns EXCEPT the TargetDimensionValueID column
                { field: 'I' },
                { field: 'II' },
                { field: 'III' },
                { field: 'IV' },
                { field: 'V' },
                { field: 'VI' },
                { field: 'VII' },
                { field: 'VIII' },
                { field: 'IX' },
                { field: 'X' },
                { field: 'XI' },
                { field: 'XII' }
            ]
        };
        // Update selection settings
        this.selectionOptions = {
            type: 'Multiple',
            cellSelectionMode: 'Box',
            mode: 'Cell',
            checkboxOnly: true


        };
        //this.selectionOptions = { type: 'Multiple', cellSelectionMode: 'Box', mode: 'Cell' };
        this.sortOptions = { columns: [{ field: 'ID', direction: 'Descending' }] };
        this.toolbar = ['Add', 'Delete', 'Cancel'];
        this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Batch', showConfirmDialog: false };
        this.id = this.route.snapshot.paramMap.get('id');
        this.companyId = JSON.parse(localStorage.getItem('currentCompany')).id;
        this.getYears();
        this.editParams = {
            params: {
                popupHeight: '300px',
                dataSource: this.dimensionValuesList,
                fields: { text: "name", value: "id" }, // Replace 'Name' and 'ID' with actual field names
                allowFiltering: true,
                query: new Query()
            },
        };


        if (this.id == "new") {
            this.object = new AllocationDefinition();
            this.object.CompanyId = this.companyId;
            this.getItems();
        }
        else {

            let promise = this.allocationDefinitionService.getById(parseInt(this.id));

            promise.then(response => {

                this.object = response;

                this.lookupService.getDimensionValuesList(response.TargetDimensionId)
                    .then((dimensionValues: Object[]) => {
                        this.dimensionValuesList = dimensionValues;
                        this.getItems();
                        this.editParams = {
                            params: {
                                popupHeight: '300px',
                                dataSource: this.dimensionValuesList,
                                fields: { text: "Name", value: "Id" }, // Replace 'Name' and 'ID' with actual field names
                                allowFiltering: true,
                                query: new Query()
                            },
                        };





                    });



            });
        }

        /* const gridElementData = document.getElementById('GridAllocationFactorsData');
        const gridPreview = (gridElementData as any).ej2_instances[0];

        if (gridPreview) {
            const rowCountData = gridPreview.getCurrentViewRecords().length;
            console.log(rowCountData);
            if (rowCountData > 0) {
                this.validateAggregates();
            } else {
                this.isDisabled = false;
            }
        }
 */



    }



    onAggregateChange(field: string, sum: number): void {
        /*console.log("onAggregateChange", field, sum);
        console.log(field, sum);
        this.aggregatedSums[field] = sum;
        console.log("aaa:", this.aggregatedSums[field])
        // Revalidate the sums
        this.validateAggregates();*/
    }

    validateAggregates(): void {
        // Check if all required column sums are valid

        this.isDisabled = Object.values(this.aggregatedSums).some(
            (sum) => parseFloat(sum.toFixed(4)) != 1.0000
        );
    }
    removeLeadingZerosRegex(str) {
        return str.replace(/^0+(?=\d)/, '');
    }
    getYears() {
        let currentYear = new Date().getFullYear();
        for (let year = 2010; year <= currentYear + 1; year++) {
            this.years.push({ value: year, name: year });
        }
        //this.year = this.years.find(y => y["value"] == currentYear);
    }

    getItems() {
        //this.initializeGridDataManagerLines(parseInt(this.id), parseInt(this.year["value"]));      
        if (this.year) {
            //this.items=null;
            this.allocationDefinitionService.getLines(parseInt(this.id), parseInt(this.year["value"]))//this.allocationDefinitionService.getLines(parseInt(this.id), parseInt(this.year["value"]))
                .then(response => {

                    // const gridElementData = document.getElementById('GridAllocationFactors1');
                    //const gridPreview = (gridElementData as any).ej2_instances[0];

                    //let updatedColumns: ColumnModel[] = this.gridAllFActors.columns as ColumnModel[];


                    let targetColumn = this.gridAllFActors.getColumnByField('TargetDimensionValueID') as ColumnModel;

                    if (targetColumn) {

                        (targetColumn.edit.params as DropDownListModel).dataSource = this.dimensionValuesList;



                        this.gridAllFActors.refreshColumns();
                        this.gridAllFActors.refresh()
                    }

                    this.items = response;
                    this.counter = 0;
                    this.queueRowRestore(this.pendingRestoreRecordId ?? this.highlightedRecordId);
                    setTimeout(() => this.updateGridHeight(), 0);

                    //this.getTotals();    
                });



        }
    }

    getTotals() {
        // this.tableData = [];

        this.sumError = false;

        Object.keys(this.totals).forEach(key => {
            this.totals[key] = 0;
        });

        this.items.forEach((item) => {


        });

        if (this.id != 'new') {
            Object.keys(this.totals).forEach(key => {
                if (this.totals[key].toFixed(4) != "1.0000")// i broj redaka veći od 0
                {
                    this.sumError = true;
                }
            });

            if (this.items.length < 1) {
                this.sumError = false;
            }
        }
    }


    saveAllocationDefinition_old(backToMenu = false) {
        this.isDisabled = true;

        // Get the grid instance
        const gridElementData = document.getElementById('GridAllocationFactorsData');
        const gridPreview = (gridElementData as any).ej2_instances[0];

        // Ensure batch edits are committed before retrieving data
        gridPreview.endEdit();

        // Get all rows, including newly added ones
        this.items = gridPreview.getCurrentViewRecords();

        let promise = this.allocationDefinitionService.updateNew(this.object);

        promise.then(response => {
            if (this.id !== 'new') {
                let promise1 = this.allocationDefinitionService.setLinesNew(parseInt(this.id), parseInt(this.year["value"]), this.items);

                promise1.then(() => {
                    if (backToMenu) {
                        this.backToMenu();
                    } else {
                        this.router.navigate(['/allocationfactors/' + response.Id]);
                    }

                    this.isDisabled = false;
                    this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Allocation definition list saved' });

                    this.ngOnInit();  // Refresh data
                }).catch(error => {
                    this.messageService.add({ severity: 'error', summary: Utils.extractSQLError(error.error) })
                });
            }
        }).catch(error => {
            this.messageService.add({ severity: 'error', summary: Utils.extractSQLError(error.error) })
            window.location.reload();
            this.ngOnInit()
        });
    }

    saveAllocationDefinition(backToMenu = false) {


        // Get the grid instance
        const gridElementData = document.getElementById('GridAllocationFactors');
        if (gridElementData != null) {

            const gridPreview = (gridElementData as any).ej2_instances[0];

            // Ensure batch edits are committed before retrieving data
            gridPreview.endEdit();
            this.captureRestoreTarget();
            //this.gridAllFActors.editModule.batchSave();


            if (this.items.length > 0) {

                this.validationAgregates();
                //Duplicirani redovi
                const grid = this.gridAllFActors;
                const data = grid.getCurrentViewRecords() as any[]; // Get grid data

                const duplicateRows = this.findDuplicates(this.items, 'TargetDimensionValueID'); // Change 'columnName' to your key field

                if (duplicateRows.length > 0) {
                    this.highlightDuplicates(duplicateRows, grid);

                    // Show message
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Saving problem',
                        detail: 'Duplicate values found. Please resolve them before saving.',
                    });

                    grid.refresh(); // Refresh grid to apply styles
                    return;
                }

                //suma alokacijskih
                if (this.isDisabled) {
                    this.messageService.add({ severity: 'error', summary: 'Saving problem', detail: 'All allocation factor sums must equal exactly 1.0000 and all lines must have Target Dimension Value specified in order to save changes' })
                    this.gridAllFActors.refresh();
                    return;
                }

                this.items.forEach(item => {
                    if (item.hasOwnProperty("Year")) {
                        item["Year"] = parseInt(this.year["value"]);
                        item["AllocationDefinitionID"] = parseInt(this.id);
                        item["AllocationDefinition"] = AllocationDefinition;


                    }
                });
            }





        }



        let response;
        this.isDisabled = true;
        let promise = this.allocationDefinitionService.updateNew(this.object)

        promise.then(oa => {
            response = oa;

            //this.isDisabled = false;
            if (this.id == 'new') {

                //no line saving
                if (backToMenu) {
                    this.backToMenu();
                } else {
                    this.router.navigate(['/allocationfactors/' + response.Id]);
                }
            }
            else //ako ima 1 ili više redaka raditi SetLines
            {


                let promise1 = this.allocationDefinitionService.setLinesNew(parseInt(this.id), parseInt(this.year["value"]), this.items)
                promise1.then(result => {
                    this.messageService.add({ severity: 'success', summary: 'Saving successful', detail: 'Allocation definition list saved' })
                    if (backToMenu) {

                        this.backToMenu();

                    } else {
                        if (this.gridAllFActors != null) {
                            this.gridAllFActors.refresh();
                        }

                        this.router.navigate(['/allocationfactors/' + response.Id]);
                    }
                    this.isDisabled = false;

                    this.getItems();

                    //this.ngOnInit()
                }).catch(error => {
                    console.log("Error")
                    this.messageService.add({ severity: 'error', summary: Utils.extractSQLError(error.error) })
                    this.ngOnInit()
                    this.isDisabled = false;

                });
            }


        }).catch(error => {
            console.log("Error", error)

            this.messageService.add({ severity: 'error', summary: Utils.extractSQLError(error.error) })
            this.isDisabled = false;

            this.ngOnInit()

        });

    }

    backToMenu() {
        this.router.navigate(['/allocationdefinitions/']);
    }

    private findDuplicates(data: any[], key: string): number[] {
        const duplicates: number[] = [];
        const seen = new Map<string, number>();

        data.forEach((item, index) => {
            const value = item[key];
            if (seen.has(value)) {
                duplicates.push(index);
                duplicates.push(seen.get(value)!);
            } else {
                seen.set(value, index);
            }
        });

        return [...new Set(duplicates)]; // Remove duplicate indices
    }

    private highlightDuplicates(duplicateRows: number[], grid: GridComponent) {
        const rows = grid.getRows(); // Get all grid rows

        rows.forEach((row, index) => {
            if (duplicateRows.includes(index)) {
                (row as HTMLElement).style.backgroundColor = 'rgba(255, 99, 71, 0.5)'; // Light red
            } else {
                (row as HTMLElement).style.backgroundColor = ''; // Reset color
            }
        });
    }

    onBeforeBatchAdd(args: any) {
        this.counter++;

        if (args.name === 'beforeBatchAdd') {

            args.defaultData = {
                ID: this.generateUniqueId(),
                AllocationDefinitionID: parseInt(this.id),
                AllocationDefinition: AllocationDefinition,
                TargetDimensionValueID: null,
                Year: parseInt(this.year["value"]),
                I: 0,
                II: 0,
                III: 0,
                IV: 0,
                V: 0,
                VI: 0,
                VII: 0,
                VIII: 0,
                IX: 0,
                X: 0,
                XI: 0,
                XII: 0

            };

        }
    }

    generateUniqueId(): number {
        console.log("generateUniqueId")
        return Math.max(...this.items.map((item) => item.ID), 0) + 1 + this.counter;
    }

    private captureRestoreTarget() {
        const batchChanges = this.gridAllFActors?.getBatchChanges?.() as any;
        const addedRecord = batchChanges?.addedRecords?.length
            ? batchChanges.addedRecords[batchChanges.addedRecords.length - 1]
            : null;
        const changedRecord = batchChanges?.changedRecords?.length
            ? batchChanges.changedRecords[batchChanges.changedRecords.length - 1]
            : null;

        const restoreRecordId = addedRecord?.ID ?? changedRecord?.ID ?? this.highlightedRecordId;

        if (restoreRecordId != null) {
            this.pendingRestoreRecordId = Number(restoreRecordId);
            this.highlightedRecordId = Number(restoreRecordId);
        }
    }

    private queueRowRestore(recordId: number | null) {
        if (recordId == null || !this.items?.length) {
            return;
        }

        const recordIndex = this.items.findIndex(item => Number(item?.ID) === Number(recordId));

        if (recordIndex < 0) {
            return;
        }

        const pageSize = Number(this.gridAllFActors?.pageSettings?.pageSize) || 100;
        this.pendingRestoreRecordId = Number(recordId);
        this.pendingRestorePageNumber = Math.floor(recordIndex / pageSize) + 1;
        this.highlightedRecordId = Number(recordId);
    }

    private reselectLastRow() {
        if (!this.gridAllFActors || !this.items?.length) {
            return;
        }

        const recordId = this.pendingRestoreRecordId ?? this.highlightedRecordId;

        if (recordId == null) {
            return;
        }

        const recordIndex = this.items.findIndex(item => Number(item?.ID) === Number(recordId));

        if (recordIndex < 0) {
            return;
        }

        const pageSize = Number(this.gridAllFActors.pageSettings?.pageSize) || 100;
        const targetPage = this.pendingRestorePageNumber ?? (Math.floor(recordIndex / pageSize) + 1);
        const currentPage = Number(this.gridAllFActors.pageSettings?.currentPage) || 1;

        if (currentPage !== targetPage) {
            this.pendingRestorePageNumber = targetPage;
            setTimeout(() => this.gridAllFActors.goToPage(targetPage), 0);
            return;
        }

        this.pendingRestoreRecordId = null;
        this.pendingRestorePageNumber = null;
        this.highlightedRecordId = Number(recordId);

        setTimeout(() => this.applyHighlightedRowState(), 0);
    }

    private applyHighlightedRowState() {
        if (!this.gridAllFActors) {
            return;
        }

        const rows = this.gridAllFActors.getRows() as HTMLElement[];
        const currentViewRecords = this.gridAllFActors.getCurrentViewRecords() as any[];

        rows.forEach((row, index) => {
            const record = currentViewRecords[index];
            const isHighlighted = Number(record?.ID) === Number(this.highlightedRecordId);

            row.classList.toggle('restored-selected-row', isHighlighted);
        });
    }

    private updateGridHeight(): void {
        const containerTop = this.allocationFactorsGridContainer?.nativeElement.getBoundingClientRect().top;

        if (containerTop == null) {
            return;
        }

        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const maxAvailableHeight = Math.max(220, viewportHeight - containerTop - 180);
        const rowCount = this.items?.length ?? 0;
        const normalizedRowCount = rowCount < 10 ? 10 : rowCount;
        const contentHeight = 120 + (Math.max(normalizedRowCount, 1) * 36) + (normalizedRowCount > 100 ? 48 : 0);
        const preferredFillHeight = Math.round(maxAvailableHeight * 0.72) + 36;

        this.gridHeight = Math.max(220, Math.min(maxAvailableHeight, Math.max(contentHeight, preferredFillHeight)));
    }




















}
